// Дополнительный значок полосы 56 (README §1.2): 40×40, radius 9, по клику
// разворачивает меню целиком. badge — жёлтый счётчик (лампочка «улучшения»).

import type { IconName } from './Icon'
import { Icon } from './Icon'
import './ui.css'

export function RailButton({ icon, title, badge, onClick }: {
  icon: IconName
  title: string
  badge?: string | number
  onClick: () => void
}) {
  return (
    <button className="abx-railbtn" title={title} onClick={onClick}>
      <Icon name={icon} size={18} />
      {badge !== undefined && badge !== '' && badge !== 0 ? <span className="abx-railbtn__badge">{badge}</span> : null}
    </button>
  )
}
